"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMacLike = void 0;
const isMacLike = () => {
    const globalObject = typeof globalThis !== 'undefined' ? globalThis : window;
    return /(Mac|iPhone|iPod|iPad)/i.test(globalObject.navigator.platform);
};
exports.isMacLike = isMacLike;
